import { put, call } from 'redux-saga/effects'; 

import { feedbackList,feedbackDetails,feedbackUpdate,feedbackUpdateStarRating, feedbackGetChiefReviewersList, actionTakenShiftGet, actionTakenShiftUpdate, actionTakenCrewGet, actionTakenCrewUpdate} from '../services/feedbackService';

import * as types from '../actions';

export function* feedbackListSaga(payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(feedbackList, payload);
      yield put({ type: types.FEEDBACK_LIST_SUCCESS, response });
    } catch(error) {
      yield put({ type: types.FEEDBACK_LIST_ERROR, error });
    }finally{
        yield put({ type: types.HIDE_LOADER})
    }
  }
  
  export function* feedbackDetailsSaga(payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(feedbackDetails, payload);
      yield put({ type: types.FEEDBACK_DETAILS_SUCCESS, response });
    } catch(error) {
      yield put({ type: types.FEEDBACK_DETAILS_ERROR, error });
    }finally{
        yield put({ type: types.HIDE_LOADER})
    }
  }

  export function* feedbackUpdateSaga(payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(feedbackUpdate, payload);
      yield put({ type: types.FEEDBACK_UPDATE_SUCCESS, response });
    } catch(error) {
      yield put({ type: types.FEEDBACK_UPDATE_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
    }
  }

  export function* feedbackUpdateStarRatingSaga(payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(feedbackUpdateStarRating, payload);
      yield put({ type: types.FEEDBACK_STAR_RATING_SUCCESS, response });
    } catch(error) {
      yield put({ type: types.FEEDBACK_STAR_RATING_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
    }
  }

  export function* feedbackGetChiefReviewersListSaga(payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(feedbackGetChiefReviewersList, payload);
      yield put({ type: types.CHIEF_REVIEWERS_LIST_SUCCESS, response });
    } catch(error) {
      yield put({ type: types.CHIEF_REVIEWERS_LIST_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
    }
  }

  export function* actionTakenShiftGetSaga (payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(actionTakenShiftGet, payload);
      yield put({ type: types.ACTION_TAKEN_SHIFT_SUCCESS, response });
    } catch(error) {
      yield put({ type: types.ACTION_TAKEN_SHIFT_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
    }
  }   

  export function* actionTakenShiftUpdateSaga (payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(actionTakenShiftUpdate, payload);
      yield put({ type: types.ACTION_TAKEN_SHIFT_UPDATE_SUCCESS, response });
    } catch(error) {
      yield put({ type: types.ACTION_TAKEN_SHIFT_UPDATE_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
    }
  }  

  export function* actionTakenCrewGetSaga (payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(actionTakenCrewGet, payload);
      yield put({ type: types.ACTION_TAKEN_CREW_SUCCESS, response });
    } catch(error) {
      yield put({ type: types.ACTION_TAKEN_CREW_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
    }
  }  

  export function* actionTakenCrewUpdateSaga (payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(actionTakenCrewUpdate, payload);
      yield put({ type: types.ACTION_TAKEN_CREW_UPDATE_SUCCESS, response });
    } catch(error) {
      yield put({ type: types.ACTION_TAKEN_CREW_UPDATE_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
    }
  }  

  